/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1IncomingWireEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_INCOMING_WIRE_EVENT_ENTITY_NAME = 'ixc.payments.v1.IncomingWireEvent';
export const ixcPaymentsV1IncomingWireEventEntity = new schema.Entity<IxcPaymentsV1IncomingWireEvent>(IXC_PAYMENTS_V1_INCOMING_WIRE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPaymentsV1IncomingWireEvent) => `${entity.metadata?.eventId}` });

